var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlueCard',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"loading":_vm.loading,"options":_vm.options,"hide-default-footer":_vm.count <= _vm.tableRows,"server-items-length":_vm.count,"items-per-page":_vm.tableRows,"mobile-breakpoint":"200","footer-props":{
      disableItemsPerPage: true,
      showCurrentPage: true,
      showFirstLastPage: true,
    }},on:{"update:page":_vm.updatePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }